import { BIModel } from './BIModel';

// CUANDO la usuaria hace click en “Continuar con Facebook” o “Continuar con Google”

export class SignStartBIModel extends BIModel {

  static eventName = 'sign_start';

  #anonymousUserId
  #method;
  #action;
  #platform;
  #currentUrl;
  #referrerUrl;
  #flow;

  constructor(userId, anonymousUserId, method, action, platform, currentUrl, referrerUrl, flow) {
    super(SignStartBIModel.eventName, userId);
    this.#anonymousUserId = anonymousUserId;
    this.#method = method;
    this.#action = action;
    this.#platform = platform;
    this.#flow = flow;
    this.#currentUrl = currentUrl;
    this.#referrerUrl = referrerUrl;
  }

  get anonymousUserId() {
    return this.#anonymousUserId;
  }

  get method() {
    return this.#method;
  }

  get action() {
    return this.#action;
  }

  get platform() {
    return this.#platform;
  }

  get currentUrl() {
    return this.#currentUrl;
  }

  get referrerUrl() {
    return this.#referrerUrl;
  }

  get flow() {
    return this.#flow;
  }

  get modelData() {
    return {
      anonymous_user_id: this.anonymousUserId,
      method: this.method,
      action: this.action,
      platform: this.platform,
      current_url: this.currentUrl,
      referrer_url: this.referrerUrl,
      flow: this.flow
    };
  }

}